module.exports = __webpack_public_path__ + "silk ems logo.8abfc99.png";